<template>
  <div class="auth-layout">
    <!-- 배경 장식 요소 -->
    <div class="bg-decoration">
      <div class="orb orb-1"></div>
      <div class="orb orb-2"></div>
      <div class="orb orb-3"></div>
    </div>

    <div class="auth-container">
      <div class="auth-header">
        <div class="logo-icon">◈</div>
        <h1 class="auth-title">QBox Admin</h1>
        <p class="auth-subtitle">관리자 시스템에 로그인하세요</p>
      </div>
      <div class="auth-content">
        <router-view />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.auth-layout {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
}

// 배경 장식 요소
.bg-decoration {
  position: absolute;
  inset: 0;
  pointer-events: none;
  overflow: hidden;
}

.orb {
  position: absolute;
  border-radius: 50%;
  filter: blur(80px);
  opacity: 0.5;
  animation: float 20s ease-in-out infinite;
}

.orb-1 {
  width: 600px;
  height: 600px;
  background: $color-primary;
  top: -200px;
  left: -100px;
  animation-delay: 0s;
}

.orb-2 {
  width: 500px;
  height: 500px;
  background: $color-secondary;
  bottom: -150px;
  right: -100px;
  animation-delay: -7s;
}

.orb-3 {
  width: 300px;
  height: 300px;
  background: $color-accent-cyan;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  animation-delay: -14s;
  opacity: 0.3;
}

@keyframes float {
  0%,
  100% {
    transform: translate(0, 0) scale(1);
  }
  25% {
    transform: translate(30px, -30px) scale(1.05);
  }
  50% {
    transform: translate(-20px, 20px) scale(0.95);
  }
  75% {
    transform: translate(-30px, -20px) scale(1.02);
  }
}

.auth-container {
  width: 100%;
  max-width: 420px;
  padding: $spacing-xl;
  position: relative;
  z-index: 1;
}

.auth-header {
  text-align: center;
  margin-bottom: $spacing-xl;
}

.logo-icon {
  font-size: 48px;
  color: $color-primary;
  margin-bottom: $spacing-md;
  text-shadow: $glow-primary;
}

.auth-title {
  font-size: $font-size-4xl;
  font-weight: $font-weight-bold;
  color: $text-primary;
  margin: 0 0 $spacing-sm;
  letter-spacing: -0.02em;
}

.auth-subtitle {
  font-size: $font-size-md;
  color: $text-tertiary;
  margin: 0;
}

.auth-content {
  @include glass-card;
  padding: $spacing-xl;
  @include slide-up;
}
</style>
